import React, { useEffect } from 'react';
import Confirmation from '../features/confirmation/Confirmation';
import { useSearchParams } from 'react-router-dom';
import { cartStore, resetFetchCart } from '../features/cart/stores/cart.slice';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { fetchUserOrderAsync, orderStore, resetFetchUserOrderStatus } from '../features/order/stores/order.slice';
import useUserCart from '../app/useUserCart';
import { handleFooterElementDisplay, handleMainElementDisplay, LoadStatus } from '../config/utils';
import FullPageLoader from '../components/FullPageLoader';

export default function ConfirmationPage() {
   const dispatch = useAppDispatch();
   const [searchParams] = useSearchParams();
   const cartId = searchParams.get('cartId');
   const { fetchCartResponse, fetchCartStatus } = useAppSelector(cartStore);
   const { fetchUserOrderStatus } = useAppSelector(orderStore);
   useUserCart({ fetchCart: true, fetchShopTasks: true });
   const isLoading = fetchCartStatus === LoadStatus.loading || fetchUserOrderStatus === LoadStatus.loading;

   useEffect(() => {
      if (fetchCartStatus === LoadStatus.complete && fetchCartResponse.success) {
         dispatch(resetFetchCart());
      }
   }, [fetchCartResponse]);

   useEffect(() => {
      if (fetchUserOrderStatus === LoadStatus.complete) {
         dispatch(resetFetchUserOrderStatus());
      }
   }, [fetchUserOrderStatus]);

   useEffect(() => {
      handleMainElementDisplay(false);
      handleFooterElementDisplay(true);
   }, []);

   useEffect(() => {
      cartId && dispatch(fetchUserOrderAsync({ cartId }));
   }, [cartId]);

   return (
      <>
         <FullPageLoader loading={isLoading} />
         <Confirmation />
      </>
   );
}
